import { combineEpics } from "redux-observable";
import { invitationSaveEffect } from "./invitations-effect";
import { passwordSaveEffect } from "./password-effect";

import {
    preferencesFetchSuccessEffect,
    preferencesResetEffect,
    preferencesSaveEffect,
    preferencesSaveSuccessEffect,
    preferencesSaveEmailNotificationsEffect,
    preferencesSaveLeaveHoursEffect,
} from "./preferences-effect";

import {
    featureFlagsFetchEffect,
    featureFlagsSaveEffect,
    featureFlagsRefetchOnOrgChangeEffect,
} from "./feature-flags-effect";

import {
    profileHydrationEffect,
    profileLoginEffect,
    profileSaveEffect,
} from "./profile-effect";

import { reportDownloadEffect, openTimesheetReportEffect, openLeaveReportEffect, timesheetReportFetchEffect, openEquipmentUsageReportEffect } from "./report-effect";
import { subscriptionEffect } from "./subscription-effect";
import { addPaymentEffect } from "./add-payment-effect";
import { cancelSubscriptionEffect } from "./cancel-subscription-effect";
import { updatePaymentEffect } from "./update-payment-effect";

const effects = combineEpics(
    invitationSaveEffect,
    preferencesFetchSuccessEffect,
    preferencesResetEffect,
    preferencesSaveEffect,
    preferencesSaveSuccessEffect,
    preferencesSaveEmailNotificationsEffect,
    preferencesSaveLeaveHoursEffect,
    featureFlagsFetchEffect,
    featureFlagsSaveEffect,
    featureFlagsRefetchOnOrgChangeEffect,
    passwordSaveEffect,
    profileHydrationEffect,
    profileLoginEffect,
    profileSaveEffect,
    reportDownloadEffect,
    openTimesheetReportEffect,
    openEquipmentUsageReportEffect,
    openLeaveReportEffect,
    timesheetReportFetchEffect,
    addPaymentEffect,
    subscriptionEffect,
    cancelSubscriptionEffect,
    updatePaymentEffect
);

export default effects;